'use client';
import React from 'react';
import Button from '@repo/ui/src/components/Button';
import createCurrencyString from '@repo/ui/src/functions/currency-functions';

interface CartFooterProps {
  isLoading: boolean;
  isEmpty: boolean;
  total: number;
  currency: string;
  locale: string;
  disabled?: boolean;
  isCheckingOut?: boolean;
  onCheckout: () => void;
  inDrawer?: boolean;
  loadingNode?: React.ReactNode;
  /** Rendered when cart is empty and inDrawer is true (e.g. "Continue Shopping" link). */
  emptyCtaNode?: React.ReactNode;
  estimatedTotalLabel?: string;
  checkoutLabel?: string;
}

const CartFooter = ({
  isLoading,
  isEmpty,
  total,
  currency,
  locale,
  disabled,
  isCheckingOut,
  onCheckout,
  inDrawer,
  loadingNode,
  emptyCtaNode,
  estimatedTotalLabel = 'Estimated Total',
  checkoutLabel = 'Continue to Checkout',
}: CartFooterProps) => {
  if (isLoading) return null;

  return (
    <>
      {isEmpty ? (
        inDrawer && emptyCtaNode
      ) : (
        <>
          <div className="flex flex-col pb-5">
            <div className="flex justify-between align-text-top">
              <h6 className="tra-text-web-heading-5 sm:tra-text-web-heading-6 text-left">
                {estimatedTotalLabel}:
              </h6>
              <h6 className="tra-text-web-heading-5 sm:tra-text-web-heading-6">
                {createCurrencyString(locale, currency, Number(total))}
              </h6>
            </div>
          </div>
          <Button
            type="submit"
            onClick={onCheckout}
            disabled={disabled || isCheckingOut}
            full
            data-testid="cart-footer-continue-to-checkout"
          >
            {isCheckingOut ? (loadingNode ?? checkoutLabel) : checkoutLabel}
          </Button>
        </>
      )}
    </>
  );
};

export default CartFooter;
